import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { Casino } from '../../../components/Games';
import { SEO } from '../../../components/seo/SEO';

export const GameDetailsContent: FC = () => {
  const location = useLocation();

  return (
    <>
      <SEO canonicalPath={location.pathname} />
      <Casino gameEnabled />
    </>
  );
};
